// Module
var code = "<p>The tag indicates the version of our API that you are using. If you are using deprecated features, newer versions may conflict with your integration.</p> ";
// Exports
module.exports = code;